export const DotIcon = () => (
  <svg
    width="4"
    height="4"
    viewBox="0 0 4 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle opacity="0.5" cx="2" cy="2.00024" r="2" fill="#A1A5A7" />
  </svg>
);
